export const isReferenceResolverSearch = resolver => {
  return 'search' in resolver && typeof resolver.search === 'function';
};